import Vue from "vue";
import { datas, utils } from "ms-vtools";
import getHttpPathMap from "@/data/system/httpPathMap.js";
import getImageSrcMap from "@/data/system/imageSrcMap.js";

import getModFieldData from "@/data/mod/modFieldData.js";

const {
    appData,
    getAppModuleData
} = datas;
const {
    categoryMapToMap,
    mapToArr
} = utils;

// 系统接口地址
Vue.prototype.$getHttpPathMap = getHttpPathMap;

// 系统所有图片的对应路径映射表
Vue.prototype.$imageSrcMap = getImageSrcMap();

// 应用相关的数据
Vue.prototype.$appData = {
    ...appData,
    themeIcons: {
        "icon-1": "bico-icon1",
        "icon-2": "bico-icon2",
        "icon-3": "bico-icon3",
        "icon-4": "bico-icon4",
        "icon-5": "bico-icon5"
    }
};

// app内类型模块配置映射
Vue.prototype.$getAppModuleMap = getAppModuleData;

/* -------- app各模块相关 --------- */
const modFieldMap = categoryMapToMap(getModFieldData(), "map");
// 工作表 字段类型映射表
Vue.prototype.$modFieldMap = modFieldMap;
// 工作表 字段类型数组
Vue.prototype.$modFieldArr = mapToArr(modFieldMap, "_key");



// WEBPACK FOOTER //
// ./src/data/index.js